interface PhotoContentProps {
  photoId: string;
}

export default function PhotoContent({ photoId }: PhotoContentProps) {
  return (
    <div>
      <p>
        Displaying photo ID: <strong>{photoId}</strong>
      </p>
      {/* Put image, video, comments, etc. here */}
    </div>
  );
}

